module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-resort-3.4600d184.jpg";